/* eslint-disable no-unused-vars */

import Vue from 'vue'
import router from '@/routes'
import store from '@/services/StoreService'
import Buefy from 'buefy'
import VeeValidateDa from 'vee-validate/dist/locale/da'
import VeeValidate, { Validator } from 'vee-validate'

import { sync } from 'vuex-router-sync'
import VueProgressiveImage from 'vue-progressive-image'
import Meta from 'vue-meta'
import Echo from 'laravel-echo'

import VueLoading from 'vue-loading-overlay'

import App from './App'
import ApiService from '@/services/ApiService'
import LocalizationService from '@/services/LocalizationService'

import MinStrippedLengthRule from '@/global/validation/rules/MinStrippedLength'
import MaxStrippedLengthRule from '@/global/validation/rules/MaxStrippedLength'
import MinImageDimensions from '@/global/validation/rules/MinImageDimensions'
import MaxImageDimensions from '@/global/validation/rules/MaxImageDimensions'

import EnValidationMessages from '@/global/validation/localization/en'
import DaValidationMessages from '@/global/validation/localization/da'

import 'vue-loading-overlay/dist/vue-loading.css'

const isProduction = process.env.NODE_ENV === 'production'

Vue.use(VueLoading)

// Filters
require('@/global/filters/strings')
require('@/global/filters/dates')

// Meta manipulation
Vue.use(Meta)

// Eventhub
Vue.prototype.$eventHub = new Vue()

// ApiService - must be after eventhub
ApiService.initialize()

// Moment.js
const moment = require('moment')

moment.locale('da')
Vue.use(require('vue-moment'), { moment })

// Buefy
Vue.use(Buefy)

// Localization
const i18n = LocalizationService.initialize()

// Validation
Validator.localize('da', VeeValidateDa)

Validator.extend('min_stripped_length', MinStrippedLengthRule)
Validator.extend('max_stripped_length', MaxStrippedLengthRule)
Validator.extend('min_dimensions', MinImageDimensions)
Validator.extend('max_dimensions', MaxImageDimensions)

Vue.use(VeeValidate, {
  locale: 'da',
  errorBagName: 'veeErrors',
  fieldsBagName: 'veeFields',

  dictionary: {
    en: { messages: EnValidationMessages.messages },
    da: { messages: DaValidationMessages.messages }
  }
})

Vue.config.errorHandler = (error, vm, info) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log(error)
  }
}

// Store route sync
const unsync = sync(store, router)

// Progressive Images
Vue.use(VueProgressiveImage)

// Setup Laravel echo

window.Pusher = require('pusher-js')

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: '123456',
  wsHost: process.env.WS_SOCKET_URL,
  wsPort: process.env.WS_SOCKET_PORT,
  wssPort: process.env.WSS_SOCKET_PORT,
  disableStats: true,
  encrypted: isProduction,
  enabledTransports: ['ws', 'wss']
})

window.Echo.connector.pusher.config.authEndpoint = `${process.env.BACKEND_URL}/broadcasting/auth`

Vue.mixin({
  data () {
    return {
      get cdnUrl () {
        return process.env.S3_CDN_URL;
      }
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  http: {
    emulateJSON: true,
    emulateHTTP: true
  },
  config: {
    productionTip: isProduction
  },
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js